/**
 * 和歌山県 名物めし 12段階（コンテンツデータ）。
 *
 * 数値（radius / mass / score / unlockScore）は他県と同じテンプレート。
 * 12品すべてが農水省「うちの郷土料理」和歌山県の27品から採ってある。
 *
 * 鯨は一切扱わない。
 *  農水省の一覧には鯨料理が載っているが、この企画では料理としても景色としても採らない。
 *  太地町も景色に入れていない。
 *
 * 和歌山ラーメンは採らない。
 *  ラーメンは他6県で使用済みで7品目になる。和歌山のものを分ける材料（スープの色、かまぼこ、
 *  卓上の早寿司とゆで卵）はすべて器の中にあり、器を描かない方針では画面に出せない。
 *  器を外すと「麺の山＋チャーシュー」になり、既出6品と区別がつかない。
 *
 * ゴンバチの油炒めとうつぼの佃煮も採らない。
 *  ゴンバチ（イタドリ）は高知（Lv3 いたどりの油いため）と、
 *  うつぼは高知（Lv9 うつぼのたたき）と、それぞれ同じ素材になる。
 *  かわりに、ぼうり（里芋の親芋）といがみの煮付け（ブダイ）を入れている。
 *
 * 生の有田みかんも採らない。
 *  GI登録も世界農業遺産の認定もなく（農水省の一覧で確認）、温州みかんの絵は
 *  愛媛の紅まどんなや他県の柑橘と衝突する。かわりにみかん餅を入れている。
 *
 * 形のばらつき。
 *  しわのある小さな実（梅干し）／角の立った白い立方体（ごま豆腐）／粒の山（しらす）／
 *  でこぼこの塊（金山寺味噌）／平たい円盤（みかん餅）／丸い大きな芋（ぼうり）／
 *  魚一尾の煮付け（いがみ）／細長い棒（さんまずし）／平たく細長い帯（太刀魚）／
 *  縄で縛った束（なれずし）／低い四角が並ぶ（こけら寿司）／大きな葉包み（めはりずし）。
 *  器を描く例外はない。
 *
 * 調査で出てきた「書いてはいけないこと」を反映している。
 *  - 那智の滝を「落差日本一」と書かない。熊野那智大社公式も県公式も断定していない。
 *  - なれずしの「日本三大なれずしの一つ」は農水省でも「といわれ」。書かない。
 *  - 有田みかん・南高梅・湯浅醤油はGI登録されていない。和歌山のGIは
 *    紀州金山寺味噌（39号）、わかやま布引だいこん（108号）、あら川の桃（133号）の3件。
 *  - 福井梅との比較文は公式で裏が取れない。書かない。
 *  - 金剛峯寺の石庭を「日本最大」と書かない。県公式の表記は「日本最大級」。
 *
 * 本番画像は public/assets/foods/wakayama/ に置く。
 *
 * 2026-10-02 確定案（audit/_確定案.csv）で料理を入れ替えた。
 * - 外した品：金山寺味噌・みかん餅・ぼうり・いがみの煮付け・なれずし・こけら寿司（店で食べられる品に差し替え）
 * - 早寿司（はやずし）：使う魚（さば）は公式資料に書かれていないので書かない（和歌山ラーメン特集の店情報に「さば寿し」とあるだけ）
 * - 早寿司（はやずし）：葉で包むかどうかは公式資料で確かめられないので書かない
 * - 早寿司（はやずし）：「日本三大なれずし」は出典にあるが、早寿司ではなくなれずしの話なので書かない
 * - グリーンソフト：作っている茶舗の名（玉林園）は店名なので書かない
 * - グリーンソフト：出典の「和歌山県民のソウルフード」は宣伝の言い回しなので書かない
 * - 和歌山ラーメン（中華そば）：1998年のテレビ番組での選出やラーメン博物館の特別展は、特定の店の話になるので書かない
 * - 和歌山ラーメン（中華そば）：系統の名（車庫前系・井出系）は、片方が店の名に由来するので書かない
 * - 和歌山ラーメン（中華そば）：屋台を始めた人・店の名と年（1940年・1953年）は店の話になるので書かない
 * - 高野山の精進料理：「胡麻豆腐を弘法大師がたいそう気に入っていた」は伝承で、出典も「伝わる」とするだけなので書かない
 * - 高野山の精進料理：「健康食・長寿食」は効能の主張に読めるので書かない
 * - 高野山の精進料理：宿坊・料理店の名は書かない
 * - 勝浦の生まぐろ丼：「全国一」は県観光連盟の記述なので「とされる」の伝聞形にした
 * - 勝浦の生まぐろ丼：市場の店の名は書かない
 * - クエ鍋：「高級魚」「絶品」は宣伝の言い回しなので書かない
 * - クエ鍋：店の名は書かない
 */

import { attachHulls } from '../../utils/itemShape';
import type { RewardLink, StageDefinition, StageItemDefinition } from '../types';

import { wakayamaSceneryTour } from './wakayamaScenes';
import { WAKAYAMA_FOOD_HULLS } from './wakayamaFoodShapes.generated';

/** 「食べに行く」導線の既定リンク（特定店の宣伝にならないよう検索リンクにする）。 */
function searchLinks(area: string, dish: string): RewardLink[] {
  return [
    {
      label: '地図で探す',
      url: `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(`${area} ${dish}`)}`,
    },
    {
      label: 'お店を調べる',
      url: `https://www.google.com/search?q=${encodeURIComponent(`${area} ${dish}`)}`,
    },
  ];
}

const FOOD_ITEMS: StageItemDefinition[] = [
  {
    id: 'umeboshi',
    level: 1,
    name: '梅干し',
    shortName: '紀州梅干し',
    image: '/assets/foods/wakayama/01_umeboshi.webp',
    radius: 17,
    mass: 1,
    score: 2,
    description: 'しわの一つずつに、潮と日ざしが宿る。',
    source:
      'https://www.maff.go.jp/j/keikaku/syokubunka/k_ryouri/search_menu/menu/umeboshi_wakayama.html',
    icon: { label: '紀州梅干し', shape: 'berry', baseColor: '#a02838', accentColor: '#5a1a28' },
    reward: {
      unlockScore: 200,
      area: 'みなべ町・田辺市',
      headline: 'みなべ町と田辺市で育つ大粒の南高梅を塩と赤しそで漬けた、皮が薄く果肉の厚い和歌山の顔。',
      tip: '南高梅は昭和40年に優良な木を選び抜いて生まれた品種で、名は南部高校に由来する。斜面の梅林と薪炭林を組み合わせた農法は世界農業遺産に認定されている。',
      links: searchLinks('みなべ町', '南高梅 梅干し'),
    },
  },
  {
    id: 'goma-dofu',
    level: 2,
    name: 'ごま豆腐',
    shortName: 'ごま豆腐',
    image: '/assets/foods/wakayama/02_goma_dofu.webp',
    radius: 21,
    mass: 1.3,
    score: 4,
    description: '山の上の台所が生んだ、白い四角。',
    source:
      'https://www.maff.go.jp/j/keikaku/syokubunka/k_ryouri/search_menu/menu/goma_toufu_wakayama.html',
    icon: { label: 'ごま豆腐', shape: 'mochi', baseColor: '#f0eee4', accentColor: '#7aa03a' },
    reward: {
      unlockScore: 500,
      area: '高野町',
      headline: '白ごまと吉野葛だけで練り上げた、高野山の精進料理から生まれたなめらかな一品。',
      tip: '高野山では千二百年ほど前、弘法大師空海が精進料理の一つとして考えたと伝えられる。肉や魚を使わない食事で不足しがちなたんぱく質をごまで補うもので、わさび醤油や酢味噌をつけて食べる。',
      links: searchLinks('高野町', 'ごま豆腐'),
    },
  },
  {
    id: 'hayazushi',
    level: 3,
    name: '早寿司（はやずし）',
    shortName: '早寿司',
    image: '/assets/foods/wakayama/03_hayazushi.webp',
    radius: 26,
    mass: 1.7,
    score: 8,
    description: '魚と塩と米飯だけで乳酸発酵させるなれずしに対し、酢を使って早く仕上げるすし。なれずしより食べやすく、和歌山では中華そばの店で出されることが多い。',
    source:
      'https://www.wakayama-kanko.or.jp/features/gourmet',
    icon: { label: '早寿司', shape: 'rice-bowl', baseColor: '#f2efe6', accentColor: '#5a7a96' },
    reward: {
      unlockScore: 1000,
      area: '和歌山市',
      headline: '中華そばの店の卓上に置かれるすし',
      tip: '和歌山の中華そばの店では、テーブルに早なれ寿司とゆで卵が置かれ、好きなときに取って食べてよい。少なめの麺を補う役目がある。',
      links: searchLinks('和歌山市', '早寿司'),
    },
  },
  {
    id: 'green-soft',
    level: 4,
    name: 'グリーンソフト',
    shortName: 'グリーンソフト',
    image: '/assets/foods/wakayama/04_green_soft.webp',
    radius: 30,
    mass: 2.2,
    score: 16,
    description: '石臼でひいた抹茶を使った緑色のソフトクリーム。1854年創業の和歌山の茶屋が1958年に売り出した。さわやかな味わいの中に、ほのかな苦みと控えめな甘みがある。',
    source:
      'https://www.wakayama-kanko.or.jp/features/detail_538.html',
    icon: { label: '抹茶ソフト', shape: 'berry', baseColor: '#a8c47a', accentColor: '#c99a5a' },
    reward: {
      unlockScore: 1800,
      area: '和歌山市',
      headline: '抹茶の緑のソフトクリーム',
      tip: 'ソフトクリームのほか、同じ名前をつけた飴やロールケーキなども作られている。',
      links: searchLinks('和歌山市', 'グリーンソフト'),
    },
  },
  {
    id: 'mehari-zushi',
    level: 5,
    name: 'めはりずし',
    shortName: 'めはりずし',
    image: '/assets/foods/wakayama/05_mehari_zushi.webp',
    radius: 36,
    mass: 2.8,
    score: 32,
    description: '葉をめくるまで、中身は見えない。',
    source:
      'https://www.maff.go.jp/j/keikaku/syokubunka/k_ryouri/search_menu/menu/mehari_zushi_wakayama.html',
    icon: { label: 'めはりずし', shape: 'feast', baseColor: '#2a5a2a', accentColor: '#f0ece0' },
    reward: {
      unlockScore: 3000,
      area: '新宮市・那智勝浦町',
      headline: '塩漬けの高菜の葉でご飯をまるごと包んだ、目を見張るほど大きな熊野の握り飯。',
      tip: '名は「目を見張るほど大きい」「うまくて目を見張る」などに由来するといわれる。日当たりの少ない山あいでもよく育つ高菜を使い、漁師や山仕事の人が仕事の合間に食べる弁当として生まれた。',
      links: searchLinks('新宮市', 'めはりずし'),
    },
  },
  {
    id: 'kamaage-shirasu',
    level: 6,
    name: '釜揚げしらす',
    shortName: '釜揚げしらす',
    image: '/assets/foods/wakayama/06_kamaage_shirasu.webp',
    radius: 42,
    mass: 3.5,
    score: 64,
    description: '白いまま、海からまっすぐ食卓へ。',
    source:
      'https://www.maff.go.jp/j/keikaku/syokubunka/k_ryouri/search_menu/menu/shirasu_don_wakayama.html',
    icon: { label: '釜揚げしらす', shape: 'fish', baseColor: '#f4f2ec', accentColor: '#9aa8b0' },
    reward: {
      unlockScore: 4500,
      area: '湯浅町・和歌山市加太',
      headline: '紀伊水道でとれた稚魚をとれたてのままゆで上げた、真っ白でふわりと軽い湯浅の名物。',
      tip: '湯浅町では一ミリ目の網を使う漁が続けられ、水揚げ後すぐ近くの工場でゆで上げる。和歌山市加太は生しらす、湯浅は釜揚げが知られ、旬は三月下旬から五月にかけて。',
      links: searchLinks('湯浅町', '釜揚げしらす'),
    },
  },
  {
    id: 'wakayama-ramen',
    level: 7,
    name: '和歌山ラーメン（中華そば）',
    shortName: '和歌山ラーメン',
    image: '/assets/foods/wakayama/07_wakayama_ramen.webp',
    radius: 46,
    mass: 4.4,
    score: 128,
    description: '豚骨と醤油のスープに細い麺の中華そば。昭和初期の屋台に始まり、地元では「中華そば」「中華」と呼ばれてきた。なるとの代わりにかまぼこをのせることが多い。麺は100〜120gと少なめで、スープが多い。',
    source:
      'https://www.wakayama-kanko.or.jp/features/detail_616.html',
    icon: { label: '中華そば', shape: 'ramen', baseColor: '#7a4a2a', accentColor: '#f2a7b8' },
    reward: {
      unlockScore: 6500,
      area: '和歌山市',
      headline: '地元では中華そばと呼ぶ',
      tip: 'スープには、醤油が前に出るすっきりしたものと、豚骨醤油のこくが深いものの2つの系統がある。少なめの麺は、飲んだ後の締めの一杯だった名残とされる。',
      links: searchLinks('和歌山市', '和歌山ラーメン'),
      official: [{ label: '和歌山県観光連盟「和歌山ラーメンの歴史・特徴」', url: 'https://www.wakayama-kanko.or.jp/features/detail_616.html' }],
    },
  },
  {
    id: 'sanma-zushi',
    level: 8,
    name: 'さんまずし',
    shortName: 'さんまずし',
    image: '/assets/foods/wakayama/08_sanma_zushi.webp',
    radius: 51,
    mass: 5.4,
    score: 256,
    description: '一尾まるごとを、鉄砲のかたちに押す。',
    source:
      'https://www.maff.go.jp/j/keikaku/syokubunka/k_ryouri/search_menu/menu/sanma_zushi_wakayama.html',
    icon: { label: 'さんまずし', shape: 'fish', baseColor: '#a8b0b8', accentColor: '#f0ece0' },
    reward: {
      unlockScore: 9000,
      area: '新宮市など熊野地方',
      headline: '頭をつけたまま開いたさんまを酢飯にのせて棒状に押した、熊野の祭りと正月の寿司。',
      tip: '南下して和歌山の沖まで来たさんまは身が締まり、寿司に向くとされる。腹から開いて塩をあて酢でしめ、巻きすで固く押すため「さえらの鉄砲」とも呼ばれる。十月から三月にかけての魚。',
      links: searchLinks('新宮市', 'さんま寿司'),
    },
  },
  {
    id: 'tachiuo-yaki',
    level: 9,
    name: '太刀魚の焼き物',
    shortName: '太刀魚焼き',
    image: '/assets/foods/wakayama/09_tachiuo_yaki.webp',
    radius: 57,
    mass: 6.6,
    score: 512,
    description: '刀の名を持つ、細く長い銀いろ。',
    source:
      'https://www.maff.go.jp/j/keikaku/syokubunka/k_ryouri/search_menu/menu/tachiuo_ryouri_wakayama.html',
    icon: { label: '太刀魚焼き', shape: 'fish', baseColor: '#c0c8d0', accentColor: '#6a6a58' },
    reward: {
      unlockScore: 12000,
      area: '有田市',
      headline: '刀のように長く銀色に光る太刀魚を、身がほろりとほどけるまで焼き上げた有田の魚。',
      tip: '有田市は県内の太刀魚水揚げの大半を占め、箕島漁港の沖の紀伊水道が好漁場。鮮度が落ちやすいため、船の上で揚がるとすぐ氷に入れる。大きなものは刺身や塩焼きに、小さなものは酢味噌で食べる。',
      links: searchLinks('有田市', '太刀魚'),
    },
  },
  {
    id: 'koyasan-shojin-ryori',
    level: 10,
    name: '高野山の精進料理',
    shortName: '精進料理',
    image: '/assets/foods/wakayama/10_koyasan_shojin_ryori.webp',
    radius: 63,
    mass: 8,
    score: 1024,
    description: '高野山の寺院で僧侶が修行の中で食べてきた料理。殺生戒の教えにもとづき、肉や魚などの生臭物を使わない。定番は胡麻豆腐で、高野豆腐も使われる。高野山の宿坊で味わえる。',
    source:
      'https://www.wakayama-kanko.or.jp/features/gourmet',
    icon: { label: '精進料理', shape: 'feast', baseColor: '#d8cdb4', accentColor: '#2a2a2a' },
    reward: {
      unlockScore: 16000,
      area: '高野町（高野山）',
      headline: '肉も魚も使わない修行の食',
      tip: '「五味五色五法五禁」を守って作られる。高野山は約1200年前に弘法大師空海が開いた山上の聖地で、2004年に世界遺産に登録された。',
      links: searchLinks('高野山', '精進料理'),
    },
  },
  {
    id: 'katsuura-nama-maguro-don',
    level: 11,
    name: '勝浦の生まぐろ丼',
    shortName: '生まぐろ丼',
    image: '/assets/foods/wakayama/11_katsuura_nama_maguro_don.webp',
    radius: 70,
    mass: 9.6,
    score: 2048,
    description: '和歌山県観光連盟によると、那智勝浦は延縄漁による生まぐろの水揚げ量が全国一。冷凍していない生のまぐろは、もちもちとした食感と濃いうまみがある。旬は冬とされる。',
    source:
      'https://www.wakayama-kanko.or.jp/features/gourmet',
    icon: { label: 'まぐろ丼', shape: 'rice-bowl', baseColor: '#a8243a', accentColor: '#2a3a2a' },
    reward: {
      unlockScore: 22000,
      area: '那智勝浦町',
      headline: '一度も冷凍しないまぐろ',
      tip: '勝浦漁港に併設の市場では、生まぐろを刺身や丼、にぎり寿司で味わえる。生まぐろの解体の実演もある。',
      links: searchLinks('那智勝浦町', '生まぐろ丼'),
    },
  },
  {
    id: 'kue-nabe',
    level: 12,
    name: 'クエ鍋',
    shortName: 'クエ鍋',
    image: '/assets/foods/wakayama/12_kue_nabe.webp',
    radius: 78,
    mass: 11.4,
    score: 4096,
    description: '体長1mを超えることもあるハタ科の大型魚クエを使う鍋。水揚げが少なく「幻の魚」と呼ばれる。脂がのりながら上品な味で、ゼラチン質の多い皮やアラも味わう。最後は雑炊でしめる。和歌山の冬の名物。',
    source:
      'https://www.wakayama-kanko.or.jp/features/58/',
    icon: { label: 'クエ鍋', shape: 'hotpot', baseColor: '#f2ede2', accentColor: '#7a5a3a' },
    reward: {
      unlockScore: 30000,
      area: '日高町',
      headline: '幻の魚を鍋で食べる',
      tip: '冬のほか、夏の産卵前にも脂がのって旬を迎える。日高町はクエの町として知られる。',
      links: searchLinks('日高町', 'クエ鍋'),
      official: [{ label: '和歌山県観光連盟「和歌山のおすすめグルメ・お土産特集」（クエ鍋の項）', url: 'https://www.wakayama-kanko.or.jp/features/gourmet' }],
    },
  },
];

/** 得点は 2 ^ level を基準にしている（GAME_TUNING.score で方式変更可能）。 */
export const wakayamaFoodStage: StageDefinition = {
  regionId: 'wakayama',
  regionName: '和歌山県',
  mode: 'food',
  title: '和歌山めしマージ',
  theme: {
    primaryColor: '#a82a40',
    secondaryColor: '#d8a848',
    accentColor: '#e8c870',
    backgroundColor: '#18100f',
  },
  /** 背景ツアー「和歌山めぐり」。軸は一日の時間。日の出の橋杭岩から、日没の円月島へ。 */
  scenery: {
    tour: wakayamaSceneryTour,
  },
  items: attachHulls(FOOD_ITEMS, WAKAYAMA_FOOD_HULLS),
};
